var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "packageWrap"
  }, [_c('el-table', {
    staticClass: "wdb100",
    attrs: {
      "data": _vm.tableData,
      "header-cell-style": {
        background: '#fdf6ec !important'
      },
      "row-style": {
        background: '#fdf6ec'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "adjustmentNo",
      "label": "Quotation (V) No.",
      "align": "center",
      "width": "110px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "applymentNo",
      "label": "Linked Transaction No.",
      "align": "center",
      "width": "140px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "billingParty",
      "label": "Billing Party",
      "align": "center"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "Service Charge",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', {
          staticClass: "fs18 fwb orange"
        }, [_vm._v(_vm._s(_vm.currencyAndAmountFormat(_vm.detail.billingCurrency, scope.row.serviceChargeTotal)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Third Party Fee",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', {
          staticClass: "fs18 fwb orange"
        }, [_vm._v(_vm._s(_vm.currencyAndAmountFormat(_vm.detail.billingCurrency, scope.row.thirdPartyFeeTotal)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Other Fee",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', {
          staticClass: "fs18 fwb orange"
        }, [_vm._v(_vm._s(_vm.currencyAndAmountFormat(_vm.detail.billingCurrency, scope.row.otherFeeTotal)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Attachments",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return _vm._l(scope.row.attachmentUrls, function (item) {
          return _c('p', {
            key: item.url
          }, [_c('a', {
            attrs: {
              "href": item.url,
              "target": "_target"
            }
          }, [_vm._v(_vm._s(item.name))])]);
        });
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "label": "Create Time",
      "width": "120px"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "align": "center",
      "label": "Status",
      "width": "110px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.adjustmentStatusFormat(scope.row.status)))])];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }